module.exports = "/assets/eeb2813696ffcf8b0759938b3a719fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IK.png
// module id = 1477
// module chunks = 0